import singleEntity from 'bento-ordering/base/reducers/singleEntity';

import { GROUP_ORDER as ENTITY } from 'bento-ordering/group_ordering/constants/entities';

const apiReducer = singleEntity(ENTITY, {
  admin_name: '',
  short_url: '',
  qrcode: null,
  per_person_spending_limit: null,
  ordering_deadline: null,
  current_diner: null
});

export default apiReducer;
